<template>
  <div class="row" v-loading="isLoading">
    <div class="col-md-6" v-show="news.length > 0">
      <div class="bg-white-shadow pt-20 pb-20 pl-20 pr-10 h-100">
        <div class="customer-news-title">
          <div class="customer-news-text">申报文件</div>
          <div class="customer-news-more" @click="handleFileMoreClick">更多<i class="el-icon-d-arrow-right"></i></div>
        </div>
        <div class="mt-10">
          <template v-for="(data, index) in files">
            <text-card
              :class="[darkClass && 'item' in darkClass ? darkClass.item : '']"
              :category="true"
              :datas="data"
              :key="index"
              :index="index"
              :hideDate="true"
            />
          </template>
        </div>
      </div>
    </div>

    <div class="col-md-6" v-show="news.length > 0">
      <div class="bg-white pt-20 pb-20 pl-20 pr-20 h-100">
        <div class="customer-news-title">
          <div class="customer-news-text">推荐期刊</div>
          <div class="customer-news-more" @click="handleJournalMoreClick">更多<i class="el-icon-d-arrow-right"></i></div>
        </div>
        <div class="mt-10 magazine-container">
          <template v-for="(data, index) in journals">
            <img 
              :src="data.coverurl" 
              :key="index" 
              :alt="data.title" 
              class="magazine-img cursor-pointer"
              @click="handleJournalClick(data)"
            >
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TextCard from "../Utility/Cards/TextCard.vue";
import { getFolderFiles } from "@/api/folders";
import { getJournals } from "@/api/journal";

import config from "@/config";
export default {
  components: {
    TextCard 
  },
  props: {
    darkClass: {
      type: Object,
    },
  },
  inject: ['dataWrapper', 'fetchStatus'],
  data: () => ({
    isLoading: true,
    news: [],
    folderid:'',
    files:[],
    journals:[]
  }),
  created() {
    this.fetchFiles();
    this.fetchJournals();
  },
  watch: {
    'fetchStatus.isFetched': {
      handler(newVal) {
        if (newVal) {
          this.news = Array.isArray(this.dataWrapper.articles) 
            ? this.dataWrapper.articles.slice(0, 6) 
            : [];

          // this.mags = Array.isArray(this.dataWrapper.articles) 
          //   ? this.dataWrapper.articles.filter(item => item.orgchannel > 0).slice(0, 3) 
          //   : [];

          this.isLoading = false;
        }
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    async fetchFiles() {
      try {
        const response = await getFolderFiles(config.FOLDER_ID,{
          filter:{
            status:100,
          }
        });
        if (response && response.list) {
          this.files = response.list.map(file => ({ ...file, title: file.name, link:file.fileurl }));
        } else {
          // console.error('响应数据格式不正确');
        }
      } catch (error) {
        // console.error('获取文件列表失败:', error);
      }
    },
    async fetchJournals() {
      try {
        const response = await getJournals({
          filter:{
            recommend:true,
            status:100,
          }
        }, 0, 3);
        if (response && response.list) {
          this.journals = response.list.map(journal => ({ ...journal, title: journal.name }));
        } else {
          // console.error('响应数据格式不正确');
        }
      } catch (error) {
        // console.error('获取期刊列表失败:', error);
      }
    },
    handleJournalClick(journal) {
      this.$router.push({ 
        name: 'JournalDetail', 
        params: { id: journal.id } 
      });
      window.scrollTo(0, 0);
    },
    handleJournalMoreClick() {
      this.$router.push({ 
        name: 'JournalList', 
      });
      window.scrollTo(0, 0);
    },
    handleFileMoreClick() {
      this.$router.push({ 
        name: 'Events', 
      });
      window.scrollTo(0, 0);
    }
  }
};
</script>
<style>
.magazine-container {
  display: flex;
  gap: 58px; /* 图片间距 */
}

.magazine-img {
  width: calc(28% - 10px);
  height: auto;
  border-radius: 4px;
  box-shadow: 0 6px 12px rgba(0,0,0,0.18);
  margin-bottom: 0; /* 移除底部边距 */
}

/* 响应式调整 - 在小屏幕上堆叠显示 */
@media (max-width: 768px) {
  .magazine-container {
    flex-direction: column;
    gap: 10px;
  }
  
  .magazine-img {
    width: 100%;
    margin-bottom: 15px;
  }
  
  /* 新增：移动端为合作期刊版块添加顶部间距 */
  .row > .col-md-6:nth-child(2) {
    margin-top: 20px;
  }
}
</style>